module.exports = __webpack_public_path__ + "img/mandarin-5.67a3f984.png";